import { useCallback } from "react";
import { useAdvancedState } from "./useAdvancedState";

interface PaginationState {
  currentPage: number;
  rowsPerPage: number;
}

interface PaginationHandlers {
  handlePageChange: (selectedPage: number) => void;
  handleRowsPerPageChange: (selectedRowsOption: number) => void;
}
export function usePagination(initialPage: number = 1, initialRowsPerPage: number = 25) {
  const {
    state,
    updateState,
  } = useAdvancedState<PaginationState>({
    currentPage: initialPage,
    rowsPerPage: initialRowsPerPage,
  });

  const handlePageChange = useCallback((selectedPage: number) => {
    updateState({ currentPage: selectedPage });
  }, [updateState]);

  const handleRowsPerPageChange = useCallback((selectedRowsOption: number) => {
    updateState({
      rowsPerPage: selectedRowsOption,
      currentPage: 1,
    });
  }, [updateState]);

  const resetPageNumber = () => {
    updateState({
      currentPage: 1,
    });
  }

  return {
    paginationState: state,
    resetPageNumber,
    setPaginationState: {
      handlePageChange,
      handleRowsPerPageChange,
    } as PaginationHandlers,
  };
}